import { Checkbox, DataHeader, DataSource, HorizontalSpacer, Layout, Switch, Tab, Table, Tabset, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutTriumphPayAuditControl extends Layout {
    checkboxIncludeServiceIncidents: Checkbox;
    checkboxOktopayOverride: Checkbox;
    checkboxReadyToBill: Checkbox;
    checkboxReadyToPay: Checkbox;
    dataheaderTpAudit: DataHeader;
    horizontalspacer1: HorizontalSpacer;
    sourceHubtranControl: DataSource;
    sourceHubtranDocTypes: DataSource;
    sourceHubtranFieldList: DataSource;
    sourceHubtranInterfaceCodes: DataSource;
    switchActive: Switch;
    tabBillingDocTypes: Tab;
    tabDataOutput: Tab;
    tabDocTypes: Tab;
    tabGeneral: Tab;
    tableDocMappings: Table;
    tableDocTypes: Table;
    tableFieldList: Table;
    tabsetControl: Tabset;
    textboxApiToken: Textbox;
    textboxApiUrl: Textbox;
    textboxExceptionHandling: Textbox;
    textboxLastrun: Textbox;
    textboxRdyBillNoninvDocTypes: Textbox;
    textboxRunInterval: Textbox;
    textboxSendCommentTypes: Textbox;
    textboxSendOrderHistTypes: Textbox;
}
